<app-home-screen-splash [sliders]="sliders" [isService]="false"></app-home-screen-splash>
<app-home-second-block [contentInformation]="information"  [isService]="false"></app-home-second-block>
<app-home-projects-block></app-home-projects-block>
<app-home-contacts></app-home-contacts>
